import React from 'react'; 
import WithConsumer from '../context/WithConsumer';
import GravityForm from "react-gravity-form";
import { Parallax } from 'react-scroll-parallax';
import  { Redirect } from 'react-router-dom';
import Foot from './Foot';

const AccountQuotes = ({ context }) => {
		 
    const posts = () => context.posts;
    const post = posts()[0];
    
    const ctxUser = () => context.user;
	const user = ctxUser();
	
	const ctxOpenOrders = () => context.openOrders;
	const openOrders = ctxOpenOrders();
    
    function toggleAccordion(event) {
		event.preventDefault();
		context.changeOpenOrder(event.target.getAttribute('data-order'));
		
	}
    
    if (post) {

			
		let orderRows = false;
		if (post.order) {
			orderRows = post.order.map((order,i) =>
	   			<div className={`c-order ${openOrders.includes(order.title) ? "state-open" : ""}`} key={i}>
	   				
	   				<a href="#" className="c-order__header" data-order={order.title} onClick={toggleAccordion}>
	   					<h3 className="c-order__header__heading" data-order={order.title}>Quote #{ order.title }</h3>
	   					<p className="c-order__header__date" data-order={order.title}>{ order.date }</p>
	   					<p className="c-order__header__items" data-order={order.title}>{ order.items } items</p>
	   					<p className="c-order__header__total" data-order={order.title}>${ Intl.NumberFormat().format(order.total.replace('.00','')) }</p>
	   				</a>
	   				
	   				<div className="c-order__body">
	   					
	   					<div className="c-order__body__inner">
	   						
	   						<div className="c-order__body__section">
	   							<h4 className="c-order__text c-order__text--strong">{post.first_name} {post.last_name}</h4>
	   							<p className="c-order__text">{post.company}<br />{post.abn}</p>
	   						</div>
	   						
	   						<div className="c-order__body__section c-order__body__section--half">
	   							<h4 className="c-order__text c-order__text--strong">Billing address</h4>
	   							<p className="c-order__text">{ post.street_address }<br />{ post.city } { post.state } { post.postcode }</p>
	   						</div>
	   						
	   						<div className="c-order__body__section c-order__body__section--half">
	   							<h4 className="c-order__text c-order__text--strong">Shipping address</h4>
	   							<p className="c-order__text">{ order.address }<br />{ order.city } { order.state } { order.postcode }</p>
	   						</div>
	   						
	   						<div className="c-order__body__section">
	   							<table className="c-order__items">
	   								<tbody>
	   									<tr className="c-order__item c-order__item--header">
											<th className="c-order__item__cell c-order__item__cell--th">Product</th>
											<th className="c-order__item__cell c-order__item__cell--th">Price</th>
											<th className="c-order__item__cell c-order__item__cell--th">Qty</th>
											<th className="c-order__item__cell c-order__item__cell--th">Total</th>
										</tr>
			   							{
				   							order.item.map((item,j) => {
			   									return (
			   										<tr className="c-order__item" key={i}>
														<td className="c-order__item__cell">
															{item.srcset && 
																<div className="c-order__item__cell__thumb">
																	<img src={item.src} alt="" />
																</div>
															}
															<div className="c-order__item__cell__header">
																{item.heading &&
																	<h5 className="c-order__item__cell__heading">{ item.heading }</h5>
																}
																{item.color &&
																	<h5 className="c-order__item__cell__subheading">{ item.color }</h5>
																}
															</div>
														</td>
														<td className="c-order__item__cell">
															{item.price &&
																<p className="c-order__item__cell__price">${ Intl.NumberFormat().format(item.price) }</p>	
															}
														</td>
														<td className="c-order__item__cell">
															{item.qty}
														</td>
														<td className="c-order__item__cell">
															{item.price &&
																<p className="c-order__item__cell__price">${ Intl.NumberFormat().format(item.price * item.qty) }</p>	
															}
														</td>
													</tr>
			   									)
			   								})
			   							}
			   						</tbody>
	   							</table>
	   						</div>
	   						
	   						<div className="c-order__body__section c-order__body__section--right">
	   							<h4 className="c-order__text c-order__text--strong">Estimated Total</h4>
	   							<p className="c-order__text">${ Intl.NumberFormat().format(order.total.replace('.00','')) } ex. GST</p>
	   						</div>
	   						
	   						<div className="c-order__body__section"></div>
	   						
	   					</div>
	   					
	   				</div>
	   				
	   			</div>
	   		);
	   	}
	    
    	return (
	    	
	    	<div className="l-block l-block--max-width ">
			        	
	        	<div className="l-grid l-grid--large-gutter">
		        	<div className="l-grid__col l-grid__col--m-8-12 l-grid__col--l-8-12">
			        	<div className="c-content-block">
			        		<h3 className="c-heading">Quote Requests</h3>
			        		
			        	</div>
						
						{!post.order &&
							<p className="c-heading c-heading--space c-heading--top-space">You have not created any quote requests yet.</p>
						}
						<div>
							{ orderRows }
						</div>
			        	
					</div>
					<div className="l-grid__col l-grid__col--m-4-12 l-grid__col--l-4-12">
						<div className="c-content-block scope-text-account">
							<hr />
							{post.help &&
								<div dangerouslySetInnerHTML={ {__html: post.help} }></div>
							}
						</div>
					</div>
				</div>
    		
			</div>
    	)
	    		    	
	} else {
		return null
	}
};
export default WithConsumer(AccountQuotes);